import React, { useMemo, Fragment } from 'react';
import { WidgetProps } from '@rjsf/core';

type TOption = { label: string, value: any };

const SelectDisplay = ({
  id,
  options,
  value,
  multiple,

}: WidgetProps) => {

  const enumOptions = options.enumOptions as TOption[];

  const selected = useMemo(() => enumOptions.filter((opt) => {
    if (multiple) {
      return Array.isArray(value) && value.includes(opt.value)
    }
    return value == opt.value
  }), [enumOptions, value, multiple]);


  return (
    <div id={id}>
      {selected.map((opt) => <Fragment key={opt.value}>{opt.label} </Fragment>)}
    </div>
  )

};

export default SelectDisplay;
